export function calculate(userReadiness) {
    const readinessList = [
        'comfortable_chair_table',
        'focus_work_at_home',
        'has_computer',
        'min_internet_connection',
        'quiet_work_space',
        'video_conference_access'
    ];

    const scorePercentage = (readinessList.filter(item => {
        return userReadiness[item] === true || userReadiness[item] === 1;
    }).length / readinessList.length) * 100;

    return Math.floor(scorePercentage);
}
